<template>
    <base-template>
        <div class="header header-redeem">
            <div class="grid-container">
                <div class="grid-x grid-padding-x">
                    <div class="cell">
                        <div class="header__content header-detail__content">                        
                            <router-link
                                :to="{
                                    name: $route.meta.backbtn.name,
                                    params: $route.params,
                                    query: $route.query,
                                }"
                                class="btn-back">
                                <i :class="`icon-${$route.meta.backbtn.icon}`" />
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <content-container>
            <template slot="content">
                <div class="content__inner">
                    <router-view :product="product" />
                </div>
            </template>

            <template slot="sidebar">
                <aside
                    class="content__aside sidebar"
                    v-if="product">
                    <div class="content__aside-inner">
                        <div class="sidebar__header">
                            <figure
                                :style="`background-image: url(${image});`">
                                <img 
                                    :src="image" 
                                    :alt="product.title">
                            </figure>
                            <div class="label-pusher">
                                <activity-label :type="product.type" />
                            </div>
                        </div>

                        <SidebarOpeningshours
                            v-if="product.type === 2"
                            :product="product" />
                        <SidebarEvents
                            v-else
                            :product="product" />
                    </div>
                </aside>
            </template>
        </content-container>
    </base-template>
</template>

<script>
import ContentContainer from '@/components/base/ContentContainer.vue';
import BaseTemplate from '@/components/base/BaseTemplate.vue';
import SidebarEvents from '@/components/redeem/SidebarEvents.vue';
import SidebarOpeningshours from '@/components/redeem/SidebarOpeningshours.vue';
import ActivityLabel from '@/components/Label.vue';
import API from '@/api';
import { FallbackImage } from '@/helpers';

export default {
    components: {
        ContentContainer,
        BaseTemplate,
        SidebarOpeningshours,
        SidebarEvents,
        ActivityLabel,
    },
    beforeRouteEnter(to, from, next) {
        API.ijstijd.getProduct(to.params.activity_id).then((response) => {
            next(vm => vm.setData(response.data.product));
        }, () => {
            next('404');
        });
    },
    data() {
        return {
            product: null,
        };
    },
    methods: {
        setData(product) {
            this.product = Object.assign({}, {
                location: {},
                provider: {},
            }, product);
        },
    },
    computed: {
        image() {
            if(!this.product.image['1240x1240']) {
                return FallbackImage(this.product.id);
            } else {
                return this.product.image['1240x1240'];
            }
        }
    }
};
</script>
